module.exports = __webpack_public_path__ + "static/TwitterShare-4c638a203bf793e5fe07d44c2869506e.png";